import * as React from 'react';

import cx from 'classnames';

import GroupAvatar from 'groups/components/GroupAvatar';
import GroupName from 'groups/components/GroupName';

import './styles/JoinAvatarPanel.scss';

type Props = {
  groupAvatar: React.ReactElement<any, typeof GroupAvatar>;
  possessiveSignature: string;
  orgName: string | null;
  groupCode: string;
  className: string;
};

class JoinGroupAvatarPanel extends React.Component<Props> {
  render() {
    const { groupAvatar, possessiveSignature, orgName, groupCode, className } = this.props;

    return (
      <div className={cx('JoinAvatarPanel', className)}>
        <div className="JoinAvatarPanel-Image">{groupAvatar}</div>

        <div className="JoinAvatarPanel-Header">
          <h4>
            <p>{possessiveSignature}</p>
            <strong>
              <GroupName group={{ className }} />
            </strong>
          </h4>
        </div>

        <div className="JoinAvatarPanel-Footer">
          <div>{orgName}</div>
          <div>{groupCode}</div>
        </div>
      </div>
    );
  }
}

export default JoinGroupAvatarPanel;
